/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Creators_RetryInputs */

const vi_order_export_creators_retry = /** @type {(inputs: Order_Export_Creators_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

/**

* @param {Order_Export_Creators_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_creators_retry = /** @type {((inputs?: Order_Export_Creators_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Creators_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_creators_retry(inputs)
});